import React from 'react'
import Slider from 'react-slick'

import HomeSlide from './../HomeSlide'

export default ({ sliderSettings, trips }) => (
  <div id="home-slider" className="home__slider">
    {trips.length > 0 &&
      <Slider {...sliderSettings} className="carousel">
        {
          trips.map(trip => <HomeSlide key={trip.id} trip={trip} />)
        }
      </Slider>
    }
  </div>
)


// WEBPACK FOOTER //
// ./src/components/Home/HomeSlider/HomeSlider.js